
export const awards = {
  introduction: {
    subTitle: '微众银行金融科技高校技术大赛',
    subTitleEn: 'FinTechathon',
    titleImg: require('../../../assets/img/awards/title-web.png'),
    mobileTitleImg: require('../../../assets/img/awards/title-wap.png'),
    certificate: require('../../../assets/img/awards/certificate.jpg'),
    mobileCertificate: require('../../../assets/img/awards/certificate.jpg'),
    intro: [
      '在深圳市地方金融监督管理局、深圳市福田区人民政府、深圳市南山区人民政府战略指导下，由深圳大学、微众银行、深圳香蜜湖国际金融科技研究院等多方联合举办的“2023 深圳国际金融科技大赛（FinTechathon）——西丽湖金融科技大学生挑战赛”于 10 月 16 日正式开赛。大赛初赛报名及作品提交阶段共历时 43 天，向大赛组委会提交报名信息的 1500 余名学生组成了近 300 支学生队伍报名参赛，最终提交了180+份作品。本届大赛所设的区块链、人工智能、产品经理三个赛道的决赛将在深圳大学进行，将产生一等奖、二等奖、三等奖各一队，获胜赛队除了能获得大赛奖杯、纸质获奖证书及独一无二的“区块链数字证书”外，还将瓜分大赛组委会准备的 69W+ 的赛事奖金。'
    ],
    introLast: [
      '值得一提的是，本届大赛所颁发的区块链数字证书，为所有获奖者提供具有唯一标识的数字化获奖凭证。该数字证书基于微众区块链技术，采用国产安全可控开源平台FISCO BCOS为底层链，上链获奖信息防篡改、可追溯、数据来源可信任。微众区块链、深圳大学微众金融科技实验室、深圳市金融区块链发展促进会（金链盟）为该数字证书提供技术支持。获奖选手可随时查看和下载，校方、招聘企业等也可以扫码快速验证证书真伪，达到可信验证、高效互通的效果。未来，区块链数字证书可进一步拓展到奖学金认证、技能培训认证等场景，为金融科技人才专业资格与资质提供便捷的查验与认证通道，助力构建金融科技人才培养可信体系。',
      '经过初赛与复赛的激烈角逐、多位专家评委的综合评估与讨论，三个赛道入围决赛的 30 支赛队名单终于出炉！以下为具体晋级名单：'
    ]
  },

  finalist: {
    title: '入围决赛队伍',
    subTitle: 'FINALIST',
    content: [
      {
        alias: 'ai',
        title: '人工智能赛道',
        color: '#E1574D',
        list: [
          {
            product: '智能汽车保险定价与驾驶行为评估：FATE 平台的应用',
            team: '数据梦想家',
            member: '刘栋、赵小婷',
            school: '北京大学'
          },
          {
            product: '用户信用评级机制',
            team: '你说我对不队',
            member: '李晨晨、施文、张世桀',
            school: '华中科技大学、东南大学'
          },
          {
            product: '考虑区域耦合和隐私保护的电力系统多区域状态估计',
            team: '108战队',
            member: '颜剑峰、田方正',
            school: '东南大学'
          },
          {
            product: 'FATE 助力直播带货“大卖”---联邦学习销售策略制定平台',
            team: '大卖队',
            member: '李洋、张骥、刘鑫',
            school: '北京理工大学'
          },
          {
            product: 'OncoFed—基于FATE的肿瘤诊断项目',
            team: 'Aa100K',
            member: '储添翼、谷曼苏、张慕翔、周荣祺、乔晓晓',
            school: '南京大学、西安电子科技大学、华东师范大学、西北工业大学、武汉大学'
          },
          {
            product: '基于横向联邦学习的通过生理数据预测高糖发生',
            team: '从容应队',
            member: '潘佳、王金逸、邹思琪',
            school: '浙江理工大学、悉尼大学、长江大学'
          },
          {
            product: '基于联邦学习-大语言模型的医疗介入产品—以病情预警、病案管理为例',
            team: '萌新队',
            member: '谭文锋、庄秦明、黄婕',
            school: '广州大学'
          },
          {
            product: '基于Langchain + FATE-ChatGLM3-6B的ESG报告生成器',
            team: '联邦大模型前途无量对不队',
            member: '王隆、高云龙、薛雨坤、李伟、杨科琅',
            school: '深圳大学'
          },
          {
            product: '基于联邦学习的车联网攻击类型检测',
            team: '卷不动队',
            member: '撒俊先、杨月腾、熊凯、张昕、郭步新',
            school: '南安普顿大学、重庆交通大学、中南林业科技大学、北京电子科技学院、北京电子科技学院'
          },
          {
            product: '安联医疗——基于FATE+ABY的高效医疗数据联邦医疗系统',
            team: 'JZLab',
            member: '付艺超、高一杰、牛晓丹',
            school: '暨南大学'
          }
        ]
      },
      {
        alias: 'blockchain',
        title: '区块链赛道',
        color: '#7652E1',
        list: [
          {
            product: 'WeTender',
            team: '我在南海大道很想捞',
            member: '丁俞嘉、代钰堃、陈炜权、熊语嘉、盛媛',
            school: '深圳大学'
          },
          {
            product: '绿融科技',
            team: '绿融科技队',
            member: '周煜寰、朱晴、罗宇翔、李希文、李筱钰',
            school: '江西师范大学、江西师范大学、同济大学、江西师范大学、上海财经大学'
          },
          {
            product: '基于区块链的供应链碳足迹一元化系统',
            team: 'TIDAL',
            member: '邓淏天、王炜杰、轩浩钧、任旭豪、梁浩天',
            school: '北京理工大学'
          },
          {
            product: '碳路-基于区块链的碳资产管理与跨境可信交易方案',
            team: '邮吾行',
            member: '张帆、宋雨、王青楠、肖轶涛、申铜博',
            school: '北京邮电大学'
          },
          {
            product: '问链',
            team: '链上说的都对',
            member: '郑惠文、王智立、王振宇、李志远、钟南海',
            school: '广东外语外贸大学、香港中文大学（深圳）、香港理工大学、中国科学技术大学、中国科学技术大学'
          },
          {
            product: '智慧兴农——从触网到触链，“红星苹果”特色农产品持“证”一键溯源',
            team: '忙而不茫',
            member: '白琪利、高慧雯、陈国翠、常嘉璇、李艺乐',
            school: '山西能源学院'
          },
          {
            product: 'SentiChain项目',
            team: 'Eshou',
            member: '卢隆基、袁瑶、伍嘉恒、林佳儿、高韬',
            school: '深圳大学'
          },
          {
            product: '基于FISCO BCOS区块链的匿名权重投票系统',
            team: '逐梦',
            member: '陈鸣远、林泽君、张诗洁、鲁宇豪、叶力涛',
            school: '深圳大学'
          },
          {
            product: 'AI4C——面向AIGC创作的文化数字产品运营平台',
            team: '啊对对队',
            member: '于祯奇、胡鑫、孙俨、杨国铭',
            school: '北京邮电大学'
          },
          {
            product: '基于FISCO BCOS的联邦学习平台',
            team: 'find your dream',
            member: '马昊滨、苏炳权',
            school: '广东工业大学'
          }
        ]
      },
      {
        alias: 'pm',
        title: '产品经理赛道',
        color: '#376EFD',
        list: [
          {
            product: '微众银行APP适老化改造——基于有养老需求家庭账户视角',
            team: '网络一线牵',
            member: '游恒威、陈暖意、毛欣宇、杜旭雯、万金鑫',
            school: '深圳大学、昆士兰大学、东南大学、上海外国语大学、中国矿业大学（北京）'
          },
          {
            product: '好基比比',
            team: '穿梭在银河的火箭队',
            member: '蒋宜芳、王泺然、刘思怡',
            school: '哈尔滨工业大学、北京林业大学、东北大学'
          },
          {
            product: '家庭财富农场——基于对话式交互的理财小程序',
            team: '欢乐农场主',
            member: '戚煜格、王小东、朱志盈、谢立夫',
            school: '浙江大学'
          },
          {
            product: 'VIVI Chatbot：新一代微众银行APP内情感智能对话服务机器人',
            team: '一路向北，同舟共济',
            member: '王彤、张奉芊成、冯一萌、张莉、王书凝',
            school: '北京大学、同济大学'
          },
          {
            product: 'WePany基于微众银行软件和预训练大语言模型的即插即用智能模块设计方案',
            team: 'WePany',
            member: '杨傲、王滨、贾舒涵、刘宇鑫、秋凤Do Thu Phuong',
            school: "北京大学、南开大学、King's college London、中国科大"
          },
          {
            product: 'Less But More',
            team: 'Go2V',
            member: '黄诗怡、李诗文',
            school: '成都信息工程大学、成都工业学院'
          },
          {
            product: 'We2000-AI猫猫岛',
            team: '猫猫岛基建小分队',
            member: '林钟宇、林洁娜、林心竹、戴一凡、范阳旭',
            school: '北京科技大学、北京师范大学、四川大学、湖北大学'
          },
          {
            product: '微微一笑智能交互式柜台服务',
            team: '不要命的打工仔',
            member: '冯赫敏、郑洁盈、李雪玥、龚雪蓝、李思涵',
            school: '香港中文大学（深圳）'
          },
          {
            product: '基于交互式对话的微众银行数字管家',
            team: '发际线和我作队',
            member: '李世中、崔茜宁、曾梓莹',
            school: '北京航空航天大学、中国传媒大学、escp商学院'
          },
          {
            product: '微众银行APP无障碍版语音Copilot',
            team: '我不知道叫什么队',
            member: '陈嫚婷、李竹林、于跃',
            school: '深圳大学'
          }
        ]
      }
    ]
  }
}
